import { render, staticRenderFns } from "./CultureDesignMaterialBorrowInfo.vue?vue&type=template&id=56a827b9&scoped=true&"
import script from "./CultureDesignMaterialBorrowInfo.vue?vue&type=script&lang=js&"
export * from "./CultureDesignMaterialBorrowInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a827b9",
  null
  
)

export default component.exports